import { GameScatterWinProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameScatterWinProperties";
export class ScatterWinLandscapeProperties extends GameScatterWinProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.scale.set(1);
        this.position.set(900, 500);
    }
}
